<template>
    <div class="app">
        <jycheader :navIndex="6"></jycheader>
        <div class="aboutour-box">
            <div class="aboutour-content-box">
                <div class="personal-center-navBox">
                    <div class="myfried-Anfu">关于我们</div>
                    <div class="myorder-center">公司信息</div>
                    <div class="order-big">
                        <div
                            class="myorder-box"
                            @click="companyInfo(0)"
                            :class="{chooseActive:menuIndex==0}"
                        ><span :class="{indexActive:menuIndex==0}"></span>网站简介</div>
                        <div
                            class="mysave-box"
                            @click="ourTel(1)"
                            :class="{chooseActive:menuIndex==1}"
                        ><span :class="{indexActive:menuIndex==1}"></span>联系我们</div>
                    </div>
                    <div class="myorder-center">帮助中心</div>
                    <div class="order-big">
                        <div
                            class="myorder-box"
                            @click="newPerson(2)"
                            :class="{chooseActive:menuIndex==2}"
                        ><span :class="{indexActive:menuIndex==2}"></span>新手上路</div>
                        <div
                            class="mysave-box"
                            @click="problem(3)"
                            :class="{chooseActive:menuIndex==3}"
                        ><span :class="{indexActive:menuIndex==3}"></span>常见问题</div>
                    </div>
                    <div class="myorder-center">拒收政策</div>
                    <div
                        class="order-big"
                        style="height: 2.875rem;"
                    >
                        <div
                            class="myorder-box"
                            style="border: 0;"
                            @click="refusePolicy(4)"
                            :class="{chooseActive:menuIndex==4}"
                        ><span :class="{indexActive:menuIndex==4}"></span>验货与拒收政策</div>
                    </div>
                </div>
                <div class="aboutour-content">
                    <div
                        class="aboutour-company-box"
                        v-if="menuIndex==0"
                    >
                        <div class="about-company-title">关于我们</div>
                        <div class="about-company-time">发布时间：2021-04-19 15:03:48</div>
                        <p>917蔬菜网是浙江成信集团旗下网站，是汇聚最新生鲜、水果、蔬菜、副食粮油的网上交易平台，由成信集团根据市场需求成功研发并投入市场。市场潜力巨大，采用各县市特许经营加盟的模式，给城市的新鲜生活带来了便捷，也为广大朋友送去了健康。</p>
                    </div>
                    <div
                        class="aboutour-tel-box"
                        v-if="menuIndex==1"
                    >
                        <div class="aboutour-tel-top">
                            <div class="tel-top-left">
                                <img
                                    src="../../assets/image/img/详情页/tel_logo.png"
                                    alt=""
                                >
                            </div>
                            <div class="tel-top-right">
                                <div class="tel-right-phone">
                                    <img
                                        src="../../assets/image/iocn/phone_tel.png"
                                        alt=""
                                    >
                                    <p>电话: 400- 0579-693 </p>
                                </div>
                                <div class="tel-right-address">
                                    <img
                                        src="../../assets/image/iocn/address_tel.png"
                                        alt=""
                                    >
                                    <p>地址: 浙江省金华市婺城区八一北街联谊大厦6楼成信消费</p>
                                </div>
                                <div class="tel-right-fax">
                                    <img
                                        src="../../assets/image/iocn/fax_tel.png"
                                        alt=""
                                    >
                                    <p>传真: 0579-873065</p>
                                </div>
                                <div class="tel-right-email">
                                    <img
                                        src="../../assets/image/iocn/email_tel.png"
                                        alt=""
                                    >
                                    <p>邮编: 321000</p>
                                </div>
                            </div>
                        </div>
                        <div class="map">
                            <img
                                src="../../assets/image/img/详情页/map_img.png"
                                alt=""
                            >
                        </div>
                    </div>
                    <div
                        class="aboutour-newPerson-box"
                        v-if="menuIndex==2"
                    >
                        <div class="aboutour-tips">
                            <span></span>新手上路
                        </div>
                        <!-- <div class="newPerson-line"></div> -->
                        <div class="newPerson-item">
                            <div class="newPerson-items">
                                <div class="newPerson-item-left">
                                    <span></span>新用户演示
                                </div>
                                <div class="newPerson-item-right">2016-03-23</div>
                            </div>
                            <div class="newPerson-items">
                                <div class="newPerson-item-left">
                                    <span></span>新用户演示
                                </div>
                                <div class="newPerson-item-right">2016-03-23</div>
                            </div>
                            <div class="newPerson-items">
                                <div class="newPerson-item-left">
                                    <span></span>新用户演示
                                </div>
                                <div class="newPerson-item-right">2016-03-23</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="aboutour-problem-box"
                        v-if="menuIndex==3"
                    >
                        <div class="aboutour-tips">
                            <span></span>常见问题
                        </div>
                        <!-- <div class="newPerson-line"></div> -->
                        <div class="newPerson-item">
                            <div class="newPerson-items">
                                <div class="newPerson-item-left">
                                    <span></span>问题问题问题问题
                                </div>
                                <div class="newPerson-item-right">2016-03-23</div>
                            </div>
                            <div class="newPerson-items">
                                <div class="newPerson-item-left">
                                    <span></span>问题问题问题问题
                                </div>
                                <div class="newPerson-item-right">2016-03-23</div>
                            </div>
                            <div class="newPerson-items">
                                <div class="newPerson-item-left">
                                    <span></span>问题问题问题问题
                                </div>
                                <div class="newPerson-item-right">2016-03-23</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="aboutour-refusePolicy-box"
                        v-if="menuIndex==4"
                    >
                        <div class="refusePolicy-tips">验货与拒收政策</div>
                        <div class="refusePolicy-time">发布时间：2016-03-23 15:03:48</div>
                        <div class="refusePolicy-line"></div>
                        <div class="refusePolicy-god">声明</div>
                        <p>1、尊敬的买家您好，您所购买的产品将于发货时间的12小时后自动默认确定收货。如有异议，请在12小时内联系客服进行处理。917竭诚为您服务，祝您购物愉快！</p>
                        <p>2、尊敬的买家您好，如您对产品不满意，由于产品特性，请在收货后确定产品质量，如有问题当面与物流人员协商退货，一旦物流人员离开后我们将不接受您的退货。917竭诚为您服务，祝您购物愉快！</p>
                        <p>3、尊敬的买家您好，如因产品问题，产生的退货，我们将在12小时内为您办理全额退款手续。如因买家自身原因，产生的退货，我们将在12小时内，扣除物流费用后为您办理退款手续。917竭诚为您服务，祝您购物愉快！</p>
                    </div>
                </div>
            </div>
        </div>
        <jycfooter></jycfooter>
        <!-- <div v-if="is_wximg" class="index-img-pos-left">
            <div><img @click="closeWxClick" style="width:25px;height:auto;cursor:pointer;margin:0 0 10px 0" src="../../assets/image/iocn/close.png"/></div>
            <img
                style="width:100%;height:auto"
                src="../../assets/image/iocn/wxxcx.png"
            />
        </div> -->
    </div>
</template>

<script>
    import jycheader from "../header.vue"
    import jycfooter from "../bottom.vue"
    export default
    {
        data()
        {
            return {
                menuIndex: 0,
                typeList: [],
                is_wximg: false,
            }
        },
        components:
        {
            jycheader,
            jycfooter
        },
        mounted()
        {
            window.scroll(0, 0)
            this.gettypeList();
            this.is_wximg = true
        },
        methods:
        {
            closeWxClick() {
                this.is_wximg = false
            },
            gettypeList()
            { //获取关于我们分类树
                this.$loading();
                this.$api.aboutour.aboutourType().then( res =>
                {
                    this.$loading().close();
                    console.log( res )
                    if ( res.data.code == 0 )
                    {
                        this.typeList = res.data.result;
                    }
                    else
                    {
                        this.checkTips( res.data.message, 'warning' );
                    }
                } )
            },
            checkTips( name, type )
            { //用户提示
                this.$message(
                {
                    message: name,
                    type: type
                } )
            },
            refusePolicy( index )
            { //拒收政策
                this.menuIndex = index;
            },
            newPerson( index )
            { //新手上路
                this.menuIndex = index;
            },
            problem( index )
            { //常见问题
                this.menuIndex = index;
            },
            companyInfo( index )
            { //公司简介
                this.menuIndex = index;
            },
            ourTel( index )
            { //联系我们
                this.menuIndex = index;
            }
        }
    }
</script>

<style scoped="scoped">
    .map {
        /* margin-top: 1.875rem; */
    }

    .map,
    .map img {
        width: 100%;
        height: 15.6875rem;
    }

    .tel-top-right {
        margin-left: 3.75rem;
    }

    .tel-right-email img {
        width: 1.5625rem;
        height: 1.0625rem;
        margin-right: 1.25rem;
    }

    .tel-right-fax img {
        width: 1.3125rem;
        height: 1.1875rem;
        margin-right: 1.25rem;
    }

    .tel-right-address img {
        width: 1.25rem;
        height: 1.625rem;
        margin-right: 1.25rem;
    }

    .tel-right-phone img {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 1.25rem;
    }

    .tel-right-phone p,
    .tel-right-address p,
    .tel-right-fax p,
    .tel-right-email p {
        color: #666666;
        font-size: 14px;
        font-weight: 400;
    }

    .tel-right-phone,
    .tel-right-address,
    .tel-right-fax,
    .tel-right-email {
        display: flex;
        align-items: center;
        margin-bottom: 2.5rem;
    }

    .tel-top-left {
        margin-top: 1.875rem;
        margin-left: 3.0625rem;
    }

    .tel-top-left,
    .tel-top-left img {
        width: 20.75rem;
        height: 7.125rem;
    }

    .aboutour-tel-top {
        display: flex;
        /* align-items: center; */
    }

    .aboutour-tel-box {
        width: 100%;
        height: auto;
        padding: 2.5rem 1.6875rem 1.875rem 1.6875rem;
    }

    .aboutour-refusePolicy-box p {
        color: #666666;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.875rem;
        margin-top: 1.25rem;
    }

    .refusePolicy-god {
        color: #333333;
        font-size: 1rem;
        font-weight: 400;
    }

    .refusePolicy-line {
        width: 100%;
        height: 0.0625rem;
        background-color: #BFBFBF;
        margin-top: 1.25rem;
        margin-bottom: 1.25rem;
    }

    .refusePolicy-time {
        font-size: 14px;
        color: #999999;
        font-weight: 400;
        line-height: 1.875rem;
        text-align: center;
    }

    .refusePolicy-tips {
        font-size: 1.125rem;
        font-weight: 400;
        color: #333333;
        text-align: center;
    }

    .aboutour-refusePolicy-box {
        width: 100%;
        height: auto;
        padding: 3.75rem 4.375rem 5.625rem 4.375rem;
    }

    .aboutour-problem-box {
        width: 100%;
        height: auto;
        padding-top: 1.875rem;
    }

    .newPerson-items {
        height: 3.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #BFBFBF;
        padding-right: 1.25rem;
    }

    .newPerson-item-right {
        color: #999999;
        font-size: 0.875rem;
        font-weight: 400;
    }

    .newPerson-item-left span {
        width: 0.3125rem;
        height: 0.3125rem;
        background-color: #4A7E5D;
        margin-right: 0.875rem;
    }

    .newPerson-item-left {
        display: flex;
        align-items: center;
        color: #333333;
        font-size: 1rem;
        font-weight: 400;
    }

    .newPerson-item {
        width: 100%;
        height: auto;
        padding-left: 1.25rem;
        padding-right: 3.125rem;
    }

    .newPerson-line {
        width: 56rem;
        height: 0.0625rem;
        background-color: #BFBFBF;
        margin-top: 1.25rem;
    }

    .aboutour-tips {
        color: #333333;
        font-size: 1.75rem;
        font-weight: 400;
        display: flex;
        align-items: center;
        line-height: 2.75rem;
        margin-bottom: 1.25rem;
    }

    .aboutour-tips span {
        display: inline-block;
        width: 0.4375rem;
        height: 1.625rem;
        background-color: #069338;
        margin-right: 1.25rem;
        border-radius: 0.1875rem;
    }

    .aboutour-newPerson-box {
        width: 100%;
        height: auto;
        padding-top: 1.5rem;
    }

    .aboutour-company-box p {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.875rem;
        text-indent: 2em;
        margin-top: 3.375rem;
    }

    .about-company-time {
        color: #999999;
        font-size: 14px;
        text-align: center;
        line-height: 1.875rem;
    }

    .about-company-title {
        color: #333333;
        text-align: center;
        font-size: 18px;
        line-height: 2.125rem;
    }

    .aboutour-company-box {
        width: 100%;
        height: auto;
        padding: 4.375rem 3.75rem 0 3.75rem;
    }

    .aboutour-content {
        width: 57.5625rem;
        height: auto;
        min-height: 29.3125rem;
        background-color: #FFFFFF;
    }

    .chooseActive {
        color: #37A115 !important;
    }

    .indexActive {
        background-color: #37A115 !important;
    }

    .order-big span {
        display: inline-block;
        width: 0.25rem;
        height: 0.25rem;
        border-radius: 50%;
        background-color: #D0D0D0;
        margin-right: 0.625rem;
    }

    .mysave-box,
    .myorder-box {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .mysave-box {
        height: 2.75rem;
        line-height: 2.75rem;
    }

    .myorder-box {
        width: 100%;
        height: 2.8125rem;
        line-height: 2.8125rem;
        border-bottom: 1px dashed #E7E7E7;
    }

    .order-big {
        padding: 0 1.5625rem;
        color: #666666;
        font-size: 14px;
        font-weight: 400;
        height: 5.6875rem;
        background-color: #FFFFFF;
    }

    .myorder-center {
        width: 100%;
        height: 2.5rem;
        line-height: 2.5rem;
        color: #333333;
        background-color: #F5F5F5;
        font-size: 16px;
        font-weight: 400;
        padding-left: 1.625rem;
    }

    .myfried-Anfu {
        width: 100%;
        height: 3.625rem;
        color: #333333;
        line-height: 3.625rem;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
    }

    .personal-center-navBox {
        width: 16.8125rem;
        height: 25.375rem;
        background-color: #FFFFFF;
    }

    .aboutour-content-box {
        width: 75rem;
        margin: auto;
        padding-top: 14px;
        display: flex;
        justify-content: space-between;
    }

    .aboutour-box {
        width: 100%;
        height: auto;
        padding-bottom: 6.25rem;
        background-color: #F1F1F1;
    }
</style>